import { render, staticRenderFns } from "./GlobalLayout.vue?vue&type=template&id=8df00a2c&scoped=true&style=overflow%3Ahidden&"
import script from "./GlobalLayout.vue?vue&type=script&lang=js&"
export * from "./GlobalLayout.vue?vue&type=script&lang=js&"
import style0 from "./GlobalLayout.vue?vue&type=style&index=0&id=8df00a2c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df00a2c",
  null
  
)

export default component.exports